var map = {
	"./Cuidarte-purple.svg": "a929",
	"./access-control.svg": "b1ff",
	"./access-point.svg": "d154",
	"./active_options.svg": "46a5",
	"./add_user.svg": "e4a5",
	"./billing.svg": "4e25",
	"./campaign.svg": "681b",
	"./celebration.svg": "c9a2",
	"./chain-2.svg": "8b8a",
	"./chain.svg": "0c33",
	"./cuidarte.svg": "ca9b",
	"./empty.svg": "8479",
	"./encounter.svg": "b437",
	"./facebook.svg": "aaa3",
	"./files.svg": "1724",
	"./guide.svg": "552c",
	"./home.svg": "86e6",
	"./invitation.svg": "5483",
	"./isaga.svg": "2ea2",
	"./log-in-outline.svg": "fbcd",
	"./log-out-outline.svg": "7bbd",
	"./logo.svg": "9b19",
	"./love.svg": "fb84",
	"./mastercard.svg": "2112",
	"./medicine-2.svg": "bb7c",
	"./medicine.svg": "45d9",
	"./messages.svg": "a0c9",
	"./no-roles.svg": "e075",
	"./password.svg": "6005",
	"./pdf.svg": "0db0",
	"./people.svg": "19b0",
	"./populations.svg": "28ab",
	"./questions.svg": "e034",
	"./reports.svg": "97b9",
	"./rest-api.svg": "9f266",
	"./robot.svg": "2b1c",
	"./sensors.svg": "de96",
	"./slogan.svg": "f178",
	"./tags.svg": "d246",
	"./thank-you.svg": "c38d",
	"./twitter.svg": "a3df",
	"./visa.svg": "0239",
	"./whatsapp.svg": "3357",
	"./work_together.svg": "9eb4",
	"./world.svg": "32d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";